import style from './EventCalendarDayitem.scss'
import in_array from 'locutus/php/array/in_array'

export default class EventCalendarDayitem extends React.Component {
  constructor() {
    super()

    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    const storedData = this.props.eventCalendar
    const classes = ['m-eventcalender__dayitem']
    const attributes = {}

    if (storedData && in_array(this.props.day.raw, storedData.dates_has_events) === true) {
      attributes['date-has-event'] = "1";
      attributes['onClick'] = this.handleClick;
    }

    this.props.key = this.props.day.raw

    if (this.props.controller.active_dayitems.get(this.props.key) === true) {
      classes.push(window.main.is_active_class)
    }

    return (
      <div class={classes.join(' ')} {...attributes} key={this.props.key}>
        <p class="m-eventcalender__dayitem__day">{this.props.day.display}</p>
        <p class="m-eventcalender__dayitem__weekday">{this.props.day.weekday}</p>
      </div>
    );
  }

  handleClick(e) {
    //clear
    document.querySelectorAll('.m-eventcalender__dayitem').forEach(item => {
      item.classList.remove(window.main.is_active_class)
    });
    document.querySelectorAll('.m-eventcalender__today').forEach(item => {
      item.classList.remove(window.main.is_active_class)
    });
    this.props.controller.active_dayitems = new Map()

    let dayitem = e.target.closest('.m-eventcalender__dayitem');
    dayitem.classList.add(window.main.is_active_class);

    this.props.controller.active_dayitems.set(this.props.key, true)

    this.props.controller.calculate_list_and_render(this.props.day.timestamp)
  }
}
